import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight, Eye, EyeOff, ShieldCheck } from 'lucide-react';
import { Logo } from '@/components/Logo';
import { Button } from '@/components/ui/Button';
import { Input, Field } from '@/components/ui/Input';
import { useAuth } from '@/lib/auth';
import { useToast } from '@/components/ui/Toast';
import { AuthSplitLayout } from '@/pages/Login';

export default function AdminLogin() {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { adminLogin } = useAuth();
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const u = await adminLogin(email, password);
      toast({ title: 'Admin authorized', description: u.name, variant: 'success' });
      navigate('/admin');
    } catch (err) {
      setError(err.response?.data?.detail || 'Admin login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthSplitLayout mode="admin">
      <div className="lg:hidden mb-10"><Logo /></div>
      <div className="text-[10px] uppercase tracking-[0.25em] text-volt mb-3 flex items-center gap-2"><ShieldCheck size={12} /> Admin Portal</div>
      <h1 className="font-heading font-black text-4xl sm:text-5xl uppercase tracking-tight leading-none">
        Operator <br />sign-in.
      </h1>
      <p className="mt-3 text-white/50 text-sm">Customer login is <Link to="/login" className="text-volt hover:underline" data-testid="goto-customer-login">here</Link>.</p>

      <form onSubmit={handleSubmit} className="mt-10 space-y-5" data-testid="admin-login-form">
        <Field label="Admin Email" htmlFor="email" error={error}>
          <Input id="email" type="email" data-testid="admin-login-email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </Field>
        <Field label="Password" htmlFor="password">
          <div className="relative">
            <Input
              id="password"
              type={show ? 'text' : 'password'}
              data-testid="admin-login-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="pr-12"
            />
            <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-volt">
              {show ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
        </Field>
        <Button type="submit" className="w-full" disabled={loading} data-testid="admin-login-submit">
          {loading ? 'Authorizing…' : <>Enter Console <ArrowRight size={16} /></>}
        </Button>
        <div className="text-center pt-2">
          <Link to="/" className="text-[10px] uppercase tracking-[0.25em] text-white/40 hover:text-volt">← Back to home</Link>
        </div>
      </form>
    </AuthSplitLayout>
  );
}
